var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.source === 'locations')?_c(_setup.FieldViewReadonlyLocation,{attrs:{"location-id":_vm.id},on:{"dismiss":_setup.handleDismiss}}):_c(_setup.FieldViewReadonlyResource,{attrs:{"id":_vm.id},on:{"dismiss":_setup.handleDismiss}})
}
var staticRenderFns = []

export { render, staticRenderFns }